import { ACTToolbarService } from 'src/app/angularJS/services/toolbar.service';
import { PermissionHelperService } from 'src/app/angularJS/services/permissionHelpers.service';

export class VariantPageController {

  public static $inject = [
    '$state',
    'product',
    'catalogue',
    'ACTToolbarService',
    'permissionHelpers',
  ];

  public permissions: InterACT.Interfaces.IProductVariantPermissions;
  public direction: string;

  constructor(
    private $state: ng.ui.IStateService,
    private product: InterACT.Interfaces.Catalogues.Product,
    private catalogue: InterACT.Interfaces.Catalogues.Catalogue,
    private ActToolbarService: ACTToolbarService,
    private permissionHelpers: PermissionHelperService
  ) {
    this.activate();
  }

  private activate() {
    this.permissions = this.permissionHelpers.getPermissionsForProductsVariants(this.catalogue);
    this.ActToolbarService.getToolbar('primary').then((toolbar) => {
      toolbar.setTitle(this.product.name);
      toolbar.setTabs([
        {
          label: 'Variants',
          sref: 'variants.list'
        },
        {
          label: 'Product Fields',
          labelShort: 'Fields',
          sref: 'variants.product_fields'
        }
      ], this.$state.current.data.selectedTab);
    });
  }
}